import { MouseEvent } from 'react'

export enum PageType {
  Quotes = 'quotes',
  Performance = 'performance',
  Charts = 'charts',
}

export interface CryptoTile {
  label: string
  ticker: string
  last: number
  change: number
  prevClose: number
  high: number
  low: number
  sparkline: number[]
  sparklineDateChanges: Record<string, string>
}

export type TileMap = Record<string, CryptoTile>

export interface TimeFrame {
  key: string
  value: string
  title?: string
}

export interface TimeFrames<Key = string> {
  active: string
  link: (timeFrame: Key) => string
  onClick: (timeFrame: Key, e: MouseEvent) => void
  timeframes: TimeFrame[]
}
